module.exports = __webpack_public_path__ + "media/src/images/list-6463f03195168df15fa5a41b8281d319.png";